import React, { useEffect, useState, useRef, Component } from 'react';
import { ImageViewerPanel } from './ImageViewerPanel';
import { InvoiceDocument } from '../types/invoice';
import { mockInvoice1Document, mockInvoice2Document, mockInvoice3Document, mockInvoiceDocument, mockInvoice5Document, mockCreditNoteDocument, mock2WayMatchingDocument, mock3WayMatchingDocument } from '../data/mockInvoices';
const STORAGE_KEY_DOCUMENT_ID = 'current_document_id';
const getDocumentById = (documentId: string): InvoiceDocument => {
  switch (documentId) {
    case '1':
      return mockInvoice1Document;
    case '2':
      return mockInvoice2Document;
    case '3':
      return mockInvoice3Document;
    case '4':
      return mockInvoiceDocument;
    case '5':
      return mockInvoice5Document;
    case '6':
      return mockCreditNoteDocument;
    case '7':
      return mock2WayMatchingDocument;
    case '8':
      return mock3WayMatchingDocument;
    default:
      return mockInvoiceDocument;
  }
};
export function DetachedViewer() {
  // Initialize with document from localStorage immediately
  const initialDocId = localStorage.getItem(STORAGE_KEY_DOCUMENT_ID) || '4';
  const [currentDocument, setCurrentDocument] = useState<InvoiceDocument>(getDocumentById(initialDocId));
  const [currentDocId, setCurrentDocId] = useState<string>(initialDocId);
  useEffect(() => {
    // Listen for messages from parent window via postMessage
    const handleMessage = (event: MessageEvent) => {
      if (event.data.type === 'DOCUMENT_CHANGED' && event.data.documentId) {
        const newDocId = event.data.documentId;
        setCurrentDocId(newDocId);
        const document = getDocumentById(newDocId);
        setCurrentDocument(document);
      }
    };
    window.addEventListener('message', handleMessage);
    // Request current document from parent window
    if (window.opener && !window.opener.closed) {
      window.opener.postMessage({
        type: 'VIEWER_READY'
      }, '*');
    }
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);
  return <div className="h-screen bg-gray-50 flex flex-col" data-id="element-80">
      {/* Header */}
      <div className="bg-white border-b border-gray-200 px-6 py-3 flex items-center justify-between flex-shrink-0" data-id="element-81">
        <div className="flex items-center gap-3" data-id="element-82">
          <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse" data-id="element-83"></div>
          <h1 className="text-lg font-semibold text-gray-900" data-id="element-84">
            Document Viewer
          </h1>
          <span className="text-sm text-gray-500" data-id="element-85">
            {currentDocument.invoiceNumber}
          </span>
        </div>
        <div className="flex items-center gap-2 text-xs text-gray-500" data-id="element-86">
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-87">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" data-id="element-88" />
          </svg>
          <span data-id="element-89">Synced with main window</span>
        </div>
      </div>

      {/* Viewer Content */}
      <div className="flex-1 overflow-hidden p-6" data-id="element-90">
        <div className="h-full" data-id="element-91">
          <ImageViewerPanel document={currentDocument} data-id="element-92" />
        </div>
      </div>
    </div>;
}